import type { ReactNode } from 'react';

import { HeroUIProvider } from '@heroui/react';
import { TanstackQueryIDBPersister } from '@milestone-portal/common/others/storage/TanstackQueryIDBPersister';
import { queryClient } from '@milestone-portal/router';
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client';
import { StrictMode } from 'react';

import { AsyncStorageGate } from './AsyncStorageGate';

export function AppContainer({ children }: { children: ReactNode }) {
  return (
    <StrictMode>
      <HeroUIProvider>
        <PersistQueryClientProvider
          client={queryClient}
          persistOptions={{ persister: TanstackQueryIDBPersister }}
        >
          <AsyncStorageGate>{children}</AsyncStorageGate>
        </PersistQueryClientProvider>
      </HeroUIProvider>
    </StrictMode>
  );
}
